/**
 * Dünner Logging-Wrapper als zentraler Indirektionspunkt, damit Tests
 * `vi.spyOn(Log, ...)` nutzen können, ohne `console` direkt zu mocken.
 */
export class Log {
  private static readonly PREFIX = '[booking]';

  /**
   * Logged beliebige Werte auf Debug-Niveau (aktuell `console.log`).
   *
   * @param context Log-Kontext/Ort
   * @param rest Werte, die geloggt werden sollen (variadisch)
   */
  public static debug(context: string, ...rest: any[]): void {
    console.log(Log.PREFIX, context, ...rest);
  }

  /**
   * Logged beliebige Werte auf Warn-Niveau (`console.warn`).
   *
   * @param context Log-Kontext/Ort
   * @param rest Werte, die geloggt werden sollen (variadisch)
   */
  public static warn(context: string, ...rest: any[]): void {
    console.warn(Log.PREFIX, context, ...rest);
  }

  /**
   * Logged einen Fehler auf Error-Niveau (`console.error`).
   *
   * @param context Log-Kontext/Ort
   * @param error Gefangener Fehler; fällt auf leeren String zurück
   * @param data Zusätzliche skalare Diagnosedaten; fällt auf leeren String zurück
   */
  public static error(
    context: string,
    error?: unknown,
    data?: Record<string, string | number | boolean | null | undefined>,
  ): void {
    console.error(Log.PREFIX, context, error ?? '', data ?? '');
  }
}
